import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './rootReducer';
import {
  persistStore,
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import budgetComparisonListenerMiddleware from 'middlewares/budgetComparisonListenerMiddleware';

import { baseApi } from 'shared/api';

import { readEventMessagesMiddleware } from 'pages/events-list/middlewares';

const additionalMiddlewares = [baseApi.middleware];

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(additionalMiddlewares)
      .prepend([
        budgetComparisonListenerMiddleware,
        readEventMessagesMiddleware,
      ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store };

export const persistor = persistStore(store);
